import { render, staticRenderFns } from "./ApiComponent.vue?vue&type=template&id=3ec7631e&scoped=true&"
import script from "./ApiComponent.vue?vue&type=script&lang=ts&"
export * from "./ApiComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ApiComponent.vue?vue&type=style&index=0&id=3ec7631e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec7631e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol,VContainer,VRow})
